import { DSNCDisclosureBox, DSResource } from 'shared-definitions/types'
import { ApiComponent, ApiComponentDisclosureBox } from 'data-source/types.wp'

interface DisclosureBoxOpts<T extends DSResource, A extends ApiComponent> {
  componentItemMapper: (input: A) => T | T[]
}

export function ncDisclosureBox<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentDisclosureBox<A>,
  opts: DisclosureBoxOpts<T, A>
): DSNCDisclosureBox<T> {
  return {
    visible: 'all',
    resource: 'nc-disclosure-box',
    blocks: input.content.flatMap(opts.componentItemMapper),
    variant: 'default',
  }
}
